import { FilterQueryParams } from 'Modules/types/filterTypes'
import humps from 'humps'

/**
 * Converts an object to query parameters, omitting certain keys based on the specified keys.
 * @param {FilterQueryParams} params The object to convert to query parameters.
 * @returns A query parameter string.
 */
export function filterParamSerializer(params: FilterQueryParams): string {
  const queryStrings = []
  // Image filters being enabled/disabled controls if items on the front-end are rendered or not
  // Not needed to filter data on iris_gui endpoints
  // Image filters could be removed higher up but it makes interfacing with queries and filterStore more cumbersome
  // than removing it at this step.

  const excludedKeys = ['image']

  Object.keys(params).forEach((key) => {
    if (excludedKeys.includes(key)) return
    const value = params[key]
    const formattedKey = `filter_${humps.decamelize(key)}`

    if (Array.isArray(value)) {
      // For arrays, join values with commas, and prefix with "filter_" followed by the key
      queryStrings.push(`${formattedKey}=${value.join(',')}`)
    } else if (value !== undefined) {
      // For non-array values, just add them as key=value pairs
      queryStrings.push(`${formattedKey}=${value}`)
    }
  })

  // Return the serialized query parameters string, joining by '&&' as requested
  return queryStrings.join('&')
}
